/**
 * log-utils.js - 로깅 유틸리티
 */
const DEBUG_MODE = true; // 나중에 Config에서 관리하도록 변경

/**
 * 표준 로그 메시지를 출력합니다.
 * @param {string} moduleId - 로그를 호출한 모듈의 ID
 * @param {string} message - 로그 메시지
 * @param {'log'|'warn'|'error'} type - 로그 타입
 */
export function log(moduleId, message, type = 'log') {
  if (!DEBUG_MODE) return;

  const timestamp = new Date().toISOString();
  console[type](`[${timestamp}] [${moduleId}] ${message}`);
}

/**
 * 애플리케이션의 커스텀 에러 클래스
 */
export class AppError extends Error {
    constructor(message, context = {}) {
        super(message);
        this.name = 'AppError';
        this.context = context;
    }
}